export class Config { 
  static get ID_CONFIG() {
    if(process.env.NODE_ENV === 'production' && window._env_.REACT_APP_IDCONFIG === '${REACT_APP_IDCONFIG}') {
        return '';
    }
    if(process.env.NODE_ENV === 'production') {
        return window._env_.REACT_APP_IDCONFIG;
    }
    return '';
  }
}
